import { enqueueSnackbar } from 'actions';

import {
	GetActivitiesRequest,
	GetElementTaskCompletionRequest,
} from '../requests/ElementViewRequests.js';

export const GET_ACTIVITIES = 'GET_ACTIVITIES';
export const GET_ELEMENT_TASK_COMPLETION = 'GET_ELEMENT_TASK_COMPLETION';

const onGetActivities = (value) => ({
	type: GET_ACTIVITIES,
	activities: value
});

const onGetElementTaskCompletion = (value) => ({
	type: GET_ELEMENT_TASK_COMPLETION,
	elementTaskCompletion: value
});

export const GetActivities = () => async (dispatch) => {
	await GetActivitiesRequest().then(response => {
		dispatch(onGetActivities(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const GetElementTaskCompletion = () => async (dispatch) => {
	await GetElementTaskCompletionRequest().then(response => {
		dispatch(onGetElementTaskCompletion(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};
